<template>
  <div class="react-micro-frontend" :id=id ref="reactRef"></div>
</template>

<script>

import { reactComponentMixin } from '@/mixins/react/reactComponentMixin';
import { REACT_COMPONENT_NAME } from '@/constants/react/component-constants';

export default {
  name: REACT_COMPONENT_NAME.FREEBIES_LIST_PAGE,
  mixins: [reactComponentMixin],
  async mounted() {
    const props = {
      notify: this.$notify,
      router: this.$router,
    };

    await this.mountReactComponent(this.$options.name, props);
  },
};
</script>